import { environment } from '../../../environments/environment';

/** Must equal the version of docs/documentation/analytics.md; every hit carries it as `tp_version`. */
export const ANALYTICS_PLAN_VERSION = '0.2.0';

export const MEASUREMENT_ID = environment.analytics.measurementId;

export const GTAG_SCRIPT_URL = 'https://www.googletagmanager.com/gtag/js';

/** Thirteen months, in seconds. */
const GA_COOKIE_LIFETIME_SECONDS = 60 * 60 * 24 * 395;

export const GA_CONFIG = {
  send_page_view: false,
  cookie_domain: 'none',
  cookie_expires: GA_COOKIE_LIFETIME_SECONDS,
  cookie_update: false,
  allow_google_signals: false,
  allow_ad_personalization_signals: false,
  tp_version: ANALYTICS_PLAN_VERSION,
} as const;

/** Basic consent mode: every signal starts denied, and only `analytics_storage` ever changes. */
export const CONSENT_DEFAULTS = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
} as const;

/** The fixed routes, as page keys. Guide and legal pages are resolved separately. */
export const KNOWN_PAGE_KEYS: ReadonlySet<string> = new Set([
  '/',
  '/catalog',
  '/catalog/pricing',
  '/catalog/guide',
  '/catalog/faq',
  '/catalog/whats-new',
  '/catalog/security',
  '/core',
  '/core/pricing',
  '/core/faq',
  '/core/whats-new',
  '/core/agent',
  '/contact',
  '/404',
]);

export const NOT_FOUND_PAGE_KEY = '/404';

/** Query parameters kept in `page_location`, with the only values the site itself generates. */
export const ALLOWED_QUERY_VALUES: Readonly<Record<string, readonly string[]>> = {
  product: ['catalog', 'core'],
  intent: ['walkthrough', 'security'],
  plan: ['essentials', 'advanced', 'complete'],
};

/** Kept on the first page of a visit only. */
export const UTM_PARAMS: readonly string[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

/**
 * A campaign tag is kept only when it looks like one: a short slug. Anything else, such as an
 * address or a name pasted into a link, is dropped rather than sent.
 */
export const CAMPAIGN_TAG_VALUE = /^[A-Za-z0-9._~+-]{1,100}$/;
